import {
  ApiBlobGetRequest,
  ApiGetRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title_storage: 'Container Storage',
    title_liftoff: 'Container Lift Off',
    title_lifton: 'Container Lift On',
    title_cleaning: 'Container Cleaning',
    title_doc_in: 'Document Fee In',
    title_doc_out: 'Document Fee Out',
    title_other_in: 'Other In',
    title_other_out: 'Other Out',
    title_trucking: 'Container Trucking',
    title_eor: 'Container EOR',
    title_pti: 'Container PTI',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Transaksi',
        href: '/adm/opr/transaksi',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_principle',
    sortDesc: true,
    fields_trucking_booking: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'code_truck',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'Doc',
        sortable: true,
      },
      {
        key: 'vendor_name',
        label: 'Vendor',
        sortable: true,
      },
      {
        key: 'destination',
        label: 'Destination',
        sortable: true,
      },
      {
        key: 'date_pickup',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'vessel_voy',
        label: 'Vessel/Voy',
        sortable: true,
      },
      {
        key: 'total_price',
        label: 'Total',
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    fields_trucking_interchange: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'code_truck',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'Doc',
        sortable: true,
      },
      {
        key: 'vendor_name',
        label: 'Vendor',
        sortable: true,
      },
      {
        key: 'destination',
        label: 'Destination',
        sortable: true,
      },
      {
        key: 'date_pickup',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'ex_vessel',
        label: 'Ex Vessel',
        sortable: true,
      },
      {
        key: 'total_price',
        label: 'Total',
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    fields_storage: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'exvessel_voy',
        label: 'Ex Vessel/Voy',
        sortable: true,
      },
      {
        key: 'tgl_eir_in',
        label: 'In',
        sortable: true,
      },
      {
        key: 'tgl_eir_out',
        label: 'Out',
        sortable: true,
      },
      {
        key: 'free_day',
        label: 'Free',
        sortable: true,
      },
      {
        key: 'add_day',
        label: 'Add',
        sortable: true,
      },
      {
        key: 'long_day',
        label: 'Long',
        sortable: true,
      },
      {
        key: 'total_price',
        label: 'Total',
        sortable: true,
      },
      {
        key: 'payment',
        label: 'Payment',
        sortable: true,
      },
    ],
    fields_liftoff: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'date_in',
        label: 'Date In',
        sortable: true,
      },
      {
        key: 'ex_vessel',
        label: 'Ex Vessel',
        sortable: true,
      },
      {
        key: 'consignee',
        label: 'Consignee',
        sortable: true,
      },
      {
        key: 'total_kredit_idr',
        label: 'IDR',
      },
      {
        key: 'total_kredit_usd',
        label: 'USD',
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    fields_lifton: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'booking_date',
        label: 'Date Out',
        sortable: true,
      },
      {
        key: 'vessel',
        label: 'Vessel',
        sortable: true,
      },
      {
        key: 'shipper',
        label: 'Shipper',
        sortable: true,
      },
      {
        key: 'price_kredit_idr',
        label: 'IDR',
      },
      {
        key: 'price_kredit_usd',
        label: 'USD',
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    fields_doc_fee_out: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'booking_date',
        label: 'Date Out',
        sortable: true,
      },
      {
        key: 'vessel',
        label: 'Vessel',
        sortable: true,
      },
      {
        key: 'shipper',
        label: 'Shipper',
        sortable: true,
      },
      {
        key: 'price_kredit_idr',
        label: 'IDR',
      },
      {
        key: 'price_kredit_usd',
        label: 'USD',
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    fields_other_out: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'booking_date',
        label: 'Date Out',
        sortable: true,
      },
      {
        key: 'vessel',
        label: 'Vessel',
        sortable: true,
      },
      {
        key: 'shipper',
        label: 'Shipper',
        sortable: true,
      },
      {
        key: 'price_kredit_idr',
        label: 'IDR',
      },
      {
        key: 'price_kredit_usd',
        label: 'USD',
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    fields_cleaning: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'date_in',
        label: 'Date In',
        sortable: true,
      },
      {
        key: 'ex_vessel',
        label: 'Ex Vessel',
        sortable: true,
      },
      {
        key: 'consignee',
        label: 'Consignee',
        sortable: true,
      },
      {
        key: 'cleaning',
        label: 'CT',
        sortable: true,
      },
      {
        key: 'total_kredit_idr',
        label: 'IDR',
      },
      {
        key: 'total_kredit_usd',
        label: 'USD',
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    fields_document_in: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'date_in',
        label: 'Date In',
        sortable: true,
      },
      {
        key: 'ex_vessel',
        label: 'Ex Vessel',
        sortable: true,
      },
      {
        key: 'consignee',
        label: 'Consignee',
        sortable: true,
      },
      {
        key: 'total_kredit_idr',
        label: 'IDR',
      },
      {
        key: 'total_kredit_usd',
        label: 'USD',
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    fields_other_in: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'date_in',
        label: 'Date In',
        sortable: true,
      },
      {
        key: 'ex_vessel',
        label: 'Ex Vessel',
        sortable: true,
      },
      {
        key: 'consignee',
        label: 'Consignee',
        sortable: true,
      },
      {
        key: 'total_kredit_idr',
        label: 'IDR',
      },
      {
        key: 'total_kredit_usd',
        label: 'USD',
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    fields_eor: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'code_eor',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'eor_date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'app_date',
        label: 'App Date',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Currency',
      },
      {
        key: 'app_total_labour',
        label: 'Labour',
        sortable: true,
      },
      {
        key: 'app_total_material',
        label: 'Material',
        sortable: true,
      },
      {
        key: 'total_eor_app',
        label: 'Total',
        sortable: true,
      },
      {
        key: 'payment',
        label: 'Payment',
      },
      {
        key: 'complete_name',
        label: 'Complete By',
      },
    ],
    fields_pti: [
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'code_pti',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'pti_date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'app_date',
        label: 'App Date',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Currency',
      },
      {
        key: 'app_labour_rate',
        label: 'Labour',
        sortable: true,
      },
      {
        key: 'app_total_material',
        label: 'Material',
        sortable: true,
      },
      {
        key: 'total_pti_app',
        label: 'Total',
        sortable: true,
      },
      {
        key: 'payment',
        label: 'Payment',
      },
    ],
    loading: false,
    detail_storage: false,
    form: {
      code_cont: '',
      cont_description: '',
      id_principle: '',
      code_principle: '',
      name_principle: '',
      prefix: '',
      number: '',
      type: 1,
    },
    form_liftoff: {
      id_principle: '',
      code_principle: '',
      name_principle: '',
      ex_vessel: '',
      doc_no: '',
      daterange: [],
      size: '',
      type: '',
      time: '',
    },
    form_lifton: {
      id_principle: '',
      code_principle: '',
      name_principle: '',
      ex_vessel: '',
      doc_no: '',
      daterange: [],
      size: '',
      type: '',
      time: '',
    },
    form_cleaning: {
      id_principle: '',
      code_principle: '',
      name_principle: '',
      ex_vessel: '',
      doc_no: '',
      daterange: [],
      size: '',
      type: '',
      doc_type: '',
    },
    form_truck_interchange: {
      id_principle: '',
      code_principle: '',
      name_principle: '',
      ex_vessel: '',
      doc_no: '',
      daterange: [],
      size: '',
      type: '',
      doc_type: '',
    },
    form_truck_booking: {
      id_principle: '',
      code_principle: '',
      name_principle: '',
      ex_vessel: '',
      doc_no: '',
      daterange: [],
      size: '',
      type: '',
      doc_type: '',
    },
    form_pti: {
      id_principle: '',
      code_principle: '',
      name_principle: '',
      ex_vessel: '',
      doc_no: '',
      daterange: [],
      size: '',
      type: '',
      time: '',
    },
    form_eor: {
      id_principle: '',
      code_principle: '',
      name_principle: '',
      ex_vessel: '',
      doc_no: '',
      daterange: [],
      size: '',
      type: '',
      time: '',
    },
  },
};

export const mutations = {
  changeTrans(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const getters = {
  form_liftoff(state) {
    return state.data.form_liftoff;
  },
  form_lifton(state) {
    return state.data.form_lifton;
  },
  form_cleaning(state) {
    return state.data.form_cleaning;
  },
  form_truck_interchange(state) {
    return state.data.form_truck_interchange;
  },
  form_truck_booking(state) {
    return state.data.form_truck_booking;
  },
  form_pti(state) {
    return state.data.form_pti;
  },
  form_eor(state) {
    return state.data.form_eor;
  },
};

export const actions = {
  async getTransStorage({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      type: form.type ? form.type : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/transaction/storage`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransStorage({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      type: form.type ? form.type : '',
      finance: 1,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiBlobGetRequest(`opr/transaction/storage`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_storage.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getDetailTransStorage({ commit, dispatch }, payload = null) {
    commit('changeTrans', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/transaction/storage/${payload.id_container_stock}`
    );
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        detail_storage: result.data.object || false,
        loading: false,
      });

      return true;
    }
  },

  async getTransPti({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_pti;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/transaction/pti`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransPti({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_pti;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      finance: 1,
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiBlobGetRequest(`opr/transaction/pti`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_pti.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTransEor({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_eor;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      id_vendor_repair: form.id_vendor_repair ? form.id_vendor_repair : '',
      bill: form.bill ? form.bill : '',
      account: form.account ? form.account : '',
      doc_type: form.doc_type ? form.doc_type : '',
      currency: form.currency ? form.currency : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/transaction/eor`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransEor({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_eor;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      id_vendor_repair: form.id_vendor_repair ? form.id_vendor_repair : '',
      bill: form.bill ? form.bill : '',
      account: form.account ? form.account : '',
      doc_type: form.doc_type ? form.doc_type : '',
      currency: form.currency ? form.currency : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiBlobGetRequest(`opr/transaction/eor`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_eor.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTransOtherOut({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_lifton;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      doc_type: form.doc_type ? form.doc_type : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/transaction/other-out`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransOtherOut({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_lifton;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      finance: 1,
      doc_type: form.doc_type ? form.doc_type : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiBlobGetRequest(`opr/transaction/other-out`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_other_out.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTransDocFeeOut({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_lifton;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      doc_type: form.doc_type ? form.doc_type : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/transaction/doc-out`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransDocFeeOut({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_lifton;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      finance: 1,
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      doc_type: form.doc_type ? form.doc_type : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiBlobGetRequest(`opr/transaction/doc-out`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_doc_fee_out.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTransLiftOn({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_lifton;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      doc_type: form.doc_type ? form.doc_type : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/transaction/lift-on`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransLiftOn({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_lifton;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      finance: 1,
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      doc_type: form.doc_type ? form.doc_type : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiBlobGetRequest(`opr/transaction/lift-on`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_lift_on.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTransLiftOff({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_liftoff;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      doc_type: form.doc_type ? form.doc_type : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/transaction/lift-off`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransLiftOff({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_liftoff;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle ? form.id_principle : '',
      finance: 1,
      type: form.type ? form.type : '',
      size: form.size ? form.size : '',
      bill: form.bill ? form.bill : '',
      doc_no: form.doc_no ? form.doc_no : '',
      ex_vessel: form.ex_vessel ? form.ex_vessel : '',
      doc_type: form.doc_type ? form.doc_type : '',
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiBlobGetRequest(`opr/transaction/lift-off`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_lift_off.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTransOtherIn({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_cleaning;

    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiGetRequest(`opr/transaction/other-in`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransOtherIn({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_cleaning;

    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      finance: 1,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiBlobGetRequest(`opr/transaction/other-in`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_other_in.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTransDocFeeIn({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_cleaning;

    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiGetRequest(`opr/transaction/doc-in`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransDocFeeIn({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_cleaning;

    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      finance: 1,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiBlobGetRequest(`opr/transaction/doc-in`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_doc_in.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTransCleaning({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_cleaning;

    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiGetRequest(`opr/transaction/cleaning`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTransCleaning({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_cleaning;

    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      finance: 1,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiBlobGetRequest(`opr/transaction/cleaning`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_cleaning.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTruckInterchange({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_truck_interchange;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiGetRequest(
      `opr/transaction/truck-interchange`,
      params
    );
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTruckInterchange({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_truck_interchange;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      finance: 1,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiBlobGetRequest(
      `opr/transaction/truck-interchange`,
      params
    );
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_truck_interchange.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },

  async getTruckBooking({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_truck_booking;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiGetRequest(`opr/transaction/truck-booking`, params);
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        items: result.data.object || [],
        total: result.data.total || 0,
        loading: false,
      });

      return true;
    }
  },

  async getExportTruckBooking({ commit, state, dispatch }) {
    commit('changeTrans', {
      loading: true,
    });

    const { data } = state;
    let form = data.form_truck_booking;
    let params = {
      q: data.search,
      export: 1,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: form.id_principle,
      ex_vessel: form.ex_vessel,
      doc_no: form.doc_no,
      finance: 1,
      start_date:
        form.daterange && form.daterange.length > 0 && form.daterange[0]
          ? moment(form.daterange[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        form.daterange && form.daterange.length > 0 && form.daterange[1]
          ? moment(form.daterange[1]).format('YYYY-MM-DD')
          : '',
      size: form.size,
      type: form.type,
      bill: form.bill,
      cleaning: form.cleaning,
      doc_type: form.doc_type,
    };

    let result = await ApiBlobGetRequest(
      `opr/transaction/truck-booking`,
      params
    );
    if (result.error) {
      showNotif(dispatch, {
        message: result.message,
        type: result.error ? 'error' : 'success',
      });

      return false;
    } else {
      commit('changeTrans', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'trans_truck_booking.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },
};
